import { authClient, API } from '../index'

export const getContactAdmin = () => {
  return authClient().get(`${API}/contact/admin`)
}

export const replaceContact = (data) => {
  return authClient().put(`${API}/contact`, data)
}

/** Solo actualiza el orden de entradas existentes */
export const reorderContact = (orders) => {
  return authClient().put(`${API}/contact/reorder`, { orders })
}

export const addContactEntry = (entry) => {
  return authClient().post(`${API}/contact/entries`, entry)
}

export const updateContactEntry = (entryId, entry) => {
  return authClient().put(`${API}/contact/entries/${entryId}`, entry)
}

export const deleteContactEntry = (entryId) => {
  return authClient().delete(`${API}/contact/entries/${entryId}`)
}
